module.exports = __webpack_public_path__ + "static/img/coe-heavy-horse-orange.953072b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coe-heavy-horse-orange.svg
// module id = luC3
// module chunks = 82